import Vue from 'vue'

const contactKey = (c) => {
  if(c.id) {
    return c.id
  }
  if(c.name) {
    return c.name
  }
  const parts = []
  if (c.firstName) parts.push(c.firstName)
  if (c.middleName) parts.push(c.middleName)
  if (c.lastName) parts.push(c.lastName)
  return parts.join(' ')
}

const findContactDeep = (list, id) => {
  const obj = list.find(c => c.id === id)
  if(obj) {
    return obj
  }
  for(let i = 0; i < list.length; i++) {
    let c = list[i]
    if(c.children) {
      const child = c.children.find(c => c.id === id)
      if(child) {
        return child
      }
    }
  }
  return undefined
}

export const mutations = {
  setCurrentView (state, view) {
    state.view = view
  },
  setNewContract (state, data) {
    state.newContract = data
  },
  setNewContractProperties (state, data) {
    Object.keys(data).forEach(key => Vue.set(state.newContract, key, data[key]))
  },
  setNewContractMetadata (state, obj) {
    state.newContractMetadata = obj || {}
  },
  setNewContractMetadataProperty (state, { key, value }) {
    Vue.set(state.newContractMetadata, key, value)
  },
  setNewContractView (state, v) {
    Vue.set(state.newContract, 'view', v)
  },
  setNewContractCategory (state, v) {
    Vue.set(state.newContract, 'category', v)
  },
  setNewContractType (state, v) {
    Vue.set(state.newContract, 'type', v)
  },
  setNewContractStatus (state, v) {
    Vue.set(state.newContract, 'status', v)
  },
  setNewContractPeriod (state, period) {
    state.newContractPeriod = period
  },
  addContact (state, value) {
    state.addContact = value
  },
  setCreatedContact (state, contact) {
    state.newContact = contact
  },
  setNewContractParties (state, list) {
    state.newContractParties = [...list]
  },
  addContractContact (state, contact) {
    const existing = state.newContractParties.find(c => contactKey(c) === contactKey(contact))
    if(existing) {
      Object.assign(existing, contact)
    } else {
      state.newContractParties.push(contact)
    }
  },
  removeContractContact (state, { item, parent}) {
    if(parent) {
      const contact = findContactDeep(state.newContractParties, parent.id)
      if(contact && contact.children) {
        Vue.set(contact, 'children', contact.children.filter(c => c.id !== item.id))
      }
    } else {
      state.newContractParties = state.newContractParties.filter(c => c.id !== item.id)
    }
  },
  updateContractContact (state, contact) {
    let obj = findContactDeep(state.newContractParties, contact.id)
    if (obj) {
      if (!contact.postalAddress) {
        contact.postalAddress = {
          address: contact.address,
          postalCode: contact.postalCode,
          city: contact.city,
          region: contact.region,
          country: contact.country
        }
      }
      const keys = ['type', 'orderIndex', 'number', 'firstName', 'lastName', 'companyName', 'title', 'postalAddress', 'email', 'telephone', 'roles', 'notes']
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i]
        Vue.set(obj, key, contact[key])
      }
    } else {
      obj = contact
      state.newContractParties.push(obj)
    }
    return obj
  },
  updateContractPeriod (state, period) {
    Vue.set(state.newContractPeriod, 'startDate', period.startDate)
    Vue.set(state.newContractPeriod, 'endDate', period.endDate)
  },
  addChildContact (state, { parent, child }) {
    const existing = state.newContractParties.find(c => contactKey(c) === contactKey(parent))
    if (existing) {
      if (existing.children) {
        Vue.set(existing.children, existing.children.length, child)
      } else {
        Vue.set(existing, 'children', [child])
      }
    }
  },
  clearNewContractData(state) {
    state.newContract = {}
    state.newContractPeriod = {}
    state.newContractParties = []
  },
  setContractDetails () {
    // Dummy mutation. An event handler in RegisterContractView will act on this mutation type.
  },
  setContractSearch(state, formData) {
    state.contractSearch = { ...formData }
  }
}
